import { useCallback, useEffect } from "react";

const InfiniteScroll = ({
    onLoadMore,
    page = 1,
    setPage,
    list = [],
    listTotalCount = 0,
    loading = false,
    loaderRef,
    loader = null,
    children
}) => {
    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (target.isIntersecting && !loading) {
                if (list?.length < listTotalCount) {
                    const nextPage = page + 1;
                    setPage(nextPage);
                    onLoadMore(nextPage);
                }
            }
        },
        [loading, page, list?.length, listTotalCount, onLoadMore, setPage]
    );

    useEffect(() => {
        const option = { root: null, rootMargin: "20px", threshold: 1.0 };
        const observer = new IntersectionObserver(handleObserver, option);
        const currentRef = loaderRef.current;

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [handleObserver, loaderRef]);

    const defaultLoader = (
        <div className="flex justify-center py-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
    );

    return (
        <>
            {children}
            
            {list?.length < listTotalCount && (
                <div ref={loaderRef}>
                    {loader || defaultLoader}
                </div>
            )}
        </>
    );
};

export default InfiniteScroll;